
const ORDERS_COLUMN = [
    {
        Header: "#",
        accessor: ""
    },
    {
        Header: "ID",
        accessor: "id",
    },
    {
        Header: "Name",
        accessor: "mapUserPatient.Patient.name"
    },
    {
        Header: "Caregiver",
        id: "caregiverUser",
        accessor: "mapUserPatient.User.name",
    },
    {
        Header: "EndDate",
        accessor: "endDate",
    },
    {
        Header: "Duration",
        accessor: "noOfDays",
    },
    // {
    //     Header: "Partner",
    //     accessor: "partner.name"
    // },
    {
        Header: "Left",
        accessor: "daysLeft",
    },
    {
        Header: "Inventory No",
        accessor: "inventoryId",
    },
    {
        Header: "Evital Med Amt(₹)",
        accessor: "evitalMedicineAmount",
    },
    {
        Header: "Service Charge(₹)",
        accessor: "serviceChargeAmount",
    },
    {
        Header: "Total Amount(₹)",
        accessor: "total",
    },
    {
        Header: "Type",
        accessor: "type",
    },
    {
        Header: "State",
        accessor: "address.state",
    },
];
const ORDER_DOWNLOAD_COLUMN = [
    {
        Header: "#",
        accessor: ""
    },
    {
        Header: "ID",
        accessor: "id",
    },
    {
        Header: "Name",
        accessor: "mapUserPatient.Patient.name"
    },
    {
        Header: "Caregiver",
        id: "caregiverUserDownload",
        accessor: "mapUserPatient.User.name",
    },
    {
        Header: "Gender",
        accessor: "mapUserPatient.Patient.gender"
    },
    {
        Header: "Age",
        accessor: "mapUserPatient.Patient.dob"
    },
    {
        Header: "DOB",
        accessor: "mapUserPatient.Patient.dob"
    },
    {
        Header: "EndDate",
        accessor: "endDate",
    },
    {
        Header: "Duration",
        accessor: "noOfDays",
    },
    {
        Header: "Partner",
        accessor: "partner.name"
    },
    {
        Header: "Left",
        accessor: "daysLeft",
    },
    {
        Header: "Inventory No",
        accessor: "inventoryId",
    },
    {
        Header: "Type",
        accessor: "type",
    },
    {
        Header: "City",
        accessor: "address.district",
    },
    {
        Header: "State",
        accessor: "address.state",
    },
    {
        Header: "Total Amount(₹)",
        accessor: "total",
    },
    {
        Header: "Pincode",
        accessor: "address.pincode",
    },
]
const REORDERS_COLUMN = [
    {
        Header: "ID",
        accessor: "id",
    },
    {
        Header: "Name",
        accessor: "mapUserPatient.Patient.name",
    },
    {
        Header: "Caregiver",
        id: "caregiverUserReorder",
        accessor: "mapUserPatient.User.name",
    },
    {
        Header: "State",
        accessor: "address.state",
    },
    {
        Header: "EndDate",
        accessor: "endDate",
    },
    {
        Header: "Duration",
        accessor: "noOfDays",
    },
    {
        Header: "Left",
        accessor: "daysLeft",
    },
    {
        Header: "Partner",
        accessor: "partner.name"
    },
    {
        Header: "Total Amount(₹)",
        accessor: "total",
    },
    {
        Header: "Note",
        accessor: "notes"
    }

];
const DIGITIZE_COLUMN = [
    {
        Header: "#",
        accessor: ""
    },
    {
        Header: "ID",
        accessor: "id",
    },
    {
        Header: "Name",
        accessor: "mapUserPatient.Patient.name"
    },
    {
        Header: "Caregiver",
        id: "caregiverUserDigitize",
        accessor: "mapUserPatient.User.name",
    },
    {
        Header: "EndDate",
        accessor: "endDate",
    },
    {
        Header: "Duration",
        accessor: "noOfDays",
    },
    {
        Header: "Partner",
        accessor: "partner.name"
    },
    {
        Header: "Left",
        accessor: "daysLeft",
    },
    {
        Header: "Inventory No",
        accessor: "inventoryId",
    },

];




const COLUMNS_FUCTIONALITIES = {
    "PRESORTED_ORDERS": ['PrintMultipleAddress', "Reorder", "Delete", "Edit", "Status", "DownloadExcel", "selectAllRows"],
    "STRIPS_ORDERS": ['PrintMultipleAddress', "Reorder", "Delete", "Edit", "Status", "DownloadExcel", "selectAllRows"],
    "ALL_ORDERS": ['PrintMultipleAddress', "Reorder", "Delete", "Edit", "Status", "DownloadExcel", "selectAllRows"],
    "ReOrder": ["Reorder", "EditOrder", "DaysLeft", "DownloadExcel"],
    "DIGITIZE": ['PrintMultipleAddress', "Delete", "Edit", "Status", "DownloadExcel"],
    "PHARMACY_ORDERS": ['PrintMultipleAddress', "Edit", "Status", "DownloadExcel", "selectAllRows"],
    "SALES_ORDERS": ['PrintMultipleAddress', "Edit", "Status", "DownloadExcel", "selectAllRows"],
}



const ORDER_TYPES = [
    "NEW_ORDER",
    "SUPPORT",
    "NEW_DIGITIZE_ORDER"
]

export { ORDERS_COLUMN, REORDERS_COLUMN, COLUMNS_FUCTIONALITIES, DIGITIZE_COLUMN, ORDER_TYPES, ORDER_DOWNLOAD_COLUMN };